import GenericLocationsScreen from './GenericLocationsScreen'

export default GenericLocationsScreen